/* tslint:disable */
/* eslint-disable */
export enum SparkLogEntityType {
  Program = 1,
  Target = 2,
  Behavior = 3
}
